import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, ViewChild, Input, Output, NgModule } from '@angular/core';
const _c0 = ["slider"];
let NgxBootstrapSliderService = /*#__PURE__*/(() => {
  class NgxBootstrapSliderService {
    constructor() {}
    static ɵfac = function NgxBootstrapSliderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxBootstrapSliderService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NgxBootstrapSliderService,
      factory: NgxBootstrapSliderService.ɵfac,
      providedIn: 'root'
    });
  }
  return NgxBootstrapSliderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxBootstrapSliderComponent = /*#__PURE__*/(() => {
  class NgxBootstrapSliderComponent {
    constructor() {}
    ngOnInit() {}
    static ɵfac = function NgxBootstrapSliderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxBootstrapSliderComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NgxBootstrapSliderComponent,
      selectors: [["mv-ngx-bootstrap-slider"]],
      standalone: false,
      decls: 2,
      vars: 0,
      template: function NgxBootstrapSliderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "p");
          i0.ɵɵtext(1, " ngx-bootstrap-slider works! ");
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return NgxBootstrapSliderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SliderComponent = /*#__PURE__*/(() => {
  class SliderComponent {
    // The slider HTML element
    sliderElement;
    // The slider object
    slider;
    initialOptions = {};
    initialStyle;
    // This property is not applied to the underlying slider element
    set style(value) {
      if (this.slider) {
        this.slider.getElement().setAttribute('style', value);
      } else {
        this.initialStyle = value;
      }
    }
    // Handle the value (two-way)
    set value(value) {
      if (this.slider) {
        this.slider.setValue(value);
      } else {
        this.initialOptions.value = value;
      }
    }
    valueChange = new EventEmitter();
    // The following properties are applied to the underlying slider element
    set min(value) {
      this.changeAttribute('min', value);
    }
    set max(value) {
      this.changeAttribute('max', value);
    }
    set step(value) {
      this.changeAttribute('step', value);
    }
    set precision(value) {
      this.changeAttribute('precision', value);
    }
    set orientation(value) {
      this.changeAttribute('orientation', value);
    }
    set range(value) {
      this.changeAttribute('range', value);
    }
    set selection(value) {
      this.changeAttribute('selection', value);
    }
    set tooltip(value) {
      this.changeAttribute('tooltip', value);
    }
    set tooltipSplit(value) {
      this.changeAttribute('tooltip_split', value);
    }
    set tooltipPosition(value) {
      this.changeAttribute('tooltip_position', value);
    }
    set handle(value) {
      this.changeAttribute('handle', value);
    }
    set reversed(value) {
      this.changeAttribute('reversed', value);
    }
    set rtl(value) {
      this.changeAttribute('rtl', value);
    }
    set enabled(value) {
      this.changeAttribute('enabled', value);
    }
    set naturalArrowKeys(value) {
      this.changeAttribute('natural_arrow_keys', value);
    }
    set ticks(value) {
      this.changeAttribute('ticks', value);
    }
    set ticksPositions(value) {
      this.changeAttribute('ticks_positions', value);
    }
    set ticksLabels(value) {
      this.changeAttribute('ticks_labels', value);
    }
    set ticksSnapBounds(value) {
      this.changeAttribute('ticks_snap_bounds', value);
    }
    set ticksTooltip(value) {
      this.changeAttribute('ticks_tooltip', value);
    }
    set scale(value) {
      this.changeAttribute('scale', value);
    }
    set labelledBy(value) {
      this.changeAttribute('labelledby', value);
    }
    set rangeHighlights(value) {
      this.changeAttribute('rangeHighlights', value);
    }
    set formatter(value) {
      this.changeAttribute('formatter', value);
    }
    set lockToTicks(value) {
      this.changeAttribute('lock_to_ticks', value);
    }
    // The following events are emitted
    slide = new EventEmitter();
    slideStart = new EventEmitter();
    slideStop = new EventEmitter();
    change = new EventEmitter();
    constructor() {}
    addChangeListeners() {
      this.slider.on('slide', value => {
        this.slide.emit(value);
      });
      this.slider.on('slideStart', value => {
        this.slideStart.emit(value);
      });
      this.slider.on('slideStop', value => {
        this.slideStop.emit(value);
      });
      this.slider.on('change', event => {
        this.change.emit(event);
        this.valueChange.emit(event.newValue);
      });
    }
    prepareSlider() {
      // We need to add the change listeners again after each refresh
      this.addChangeListeners();
      // Add the styling to the element
      this.slider.getElement().setAttribute('style', this.initialStyle);
    }
    changeAttribute(name, value) {
      if (this.slider) {
        this.slider.setAttribute(name, value);
        this.slider.refresh();
        this.prepareSlider();
      } else {
        this.initialOptions[name] = value;
      }
    }
    ngOnInit() {
      // Don't set the value over the initial options, because it will alway
      // be reset. This option seems to be a little buggy.
      let value = undefined;
      if (this.initialOptions.value) {
        value = this.initialOptions.value;
        delete this.initialOptions['value'];
      }
      this.slider = new Slider(this.sliderElement.nativeElement, this.initialOptions);
      if (value) {
        this.slider.setValue(value);
      }
      this.prepareSlider();
    }
    static ɵfac = function SliderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SliderComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SliderComponent,
      selectors: [["mv-slider"]],
      viewQuery: function SliderComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sliderElement = _t.first);
        }
      },
      inputs: {
        style: "style",
        value: "value",
        min: "min",
        max: "max",
        step: "step",
        precision: "precision",
        orientation: "orientation",
        range: "range",
        selection: "selection",
        tooltip: "tooltip",
        tooltipSplit: "tooltipSplit",
        tooltipPosition: "tooltipPosition",
        handle: "handle",
        reversed: "reversed",
        rtl: "rtl",
        enabled: "enabled",
        naturalArrowKeys: "naturalArrowKeys",
        ticks: "ticks",
        ticksPositions: "ticksPositions",
        ticksLabels: "ticksLabels",
        ticksSnapBounds: "ticksSnapBounds",
        ticksTooltip: "ticksTooltip",
        scale: "scale",
        labelledBy: "labelledBy",
        rangeHighlights: "rangeHighlights",
        formatter: "formatter",
        lockToTicks: "lockToTicks"
      },
      outputs: {
        valueChange: "valueChange",
        slide: "slide",
        slideStart: "slideStart",
        slideStop: "slideStop",
        change: "change"
      },
      standalone: false,
      decls: 2,
      vars: 0,
      consts: [["slider", ""]],
      template: function SliderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "input", null, 0);
        }
      },
      encapsulation: 2
    });
  }
  return SliderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxBootstrapSliderModule = /*#__PURE__*/(() => {
  class NgxBootstrapSliderModule {
    static ɵfac = function NgxBootstrapSliderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxBootstrapSliderModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NgxBootstrapSliderModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return NgxBootstrapSliderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-bootstrap-slider
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxBootstrapSliderComponent, NgxBootstrapSliderModule, NgxBootstrapSliderService, SliderComponent };
